// Loader.js
import React from 'react';
import loader from '../../components/icons/loads.gif';

const Loader = (props) => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ textAlign: 'center', padding: '20px', height: '420px' }}>
            <img width={(props.absolute && props.absolute==true) ? '15%' : '8%'} src={loader} alt="Loading..." style={{background: "white", padding: "20px", borderRadius: "20px", boxShadow: "1px 2px 5px 0px #a2a2a2"}} />
        </div>
    );
};

export default Loader;
